module.exports = __webpack_public_path__ + "media/images/apple-badge-65d112c45ec26cc751522297c0f99c3f.png";